export const I18N_NS = 'createInvoiceNew';
